export default __webpack_public_path__ + "static/images/Jihyo_1_thumb.png";